export const HoverShowOverlay = {
  mounted() {
    const targetId = this.el.dataset.hoverTarget;
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    const isDisabled = () => this.el.dataset.disabled === "true";

    const show = () => {
      if (isDisabled()) return;
      target.classList.add("opacity-100");
      target.classList.remove("opacity-0");
    };

    const hide = () => {
      target.classList.add("opacity-0");
      target.classList.remove("opacity-100");
    };

    this.el.addEventListener("mouseenter", show);
    this.el.addEventListener("mouseleave", hide);
    this.el.addEventListener("focus", show);
    this.el.addEventListener("blur", hide);

    this.cleanup = () => {
      this.el.removeEventListener("mouseenter", show);
      this.el.removeEventListener("mouseleave", hide);
      this.el.removeEventListener("focus", show);
      this.el.removeEventListener("blur", hide);
      hide();
    };
  },

  destroyed() {
    this.cleanup?.();
  },
};
